import React, {Component} from 'react'
import {Col, Row, CardHeader, CardBody, Button, Table} from 'reactstrap'
import PropTypes from 'prop-types'
import {GroupsFetchQuery} from './mutations'
import {graphql} from 'react-apollo'
import {UnmountClosed} from 'react-collapse'
import GroupForm from './GroupForm'
import {getUserPermissions} from '../../utils/userPermissions'
import BlockWithLoader from '../Support/BlockWithLoader'

class GroupsList extends Component {

  constructor(props) {
    super(props)
    this.state = {
      form_is_opened: false,
      data_to_edit: {},
    }

    this.handleFormToggle = this.handleFormToggle.bind(this)
    this.clearEditData = this.clearEditData.bind(this)
    this.afterSubmit = this.afterSubmit.bind(this)
  }

  static propTypes = {
    location: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  }

  handleFormToggle() {
    this.setState({form_is_opened: !this.state.form_is_opened})
  }

  clearEditData() {
    this.setState({data_to_edit: {}})
  }

  afterSubmit() {
    this.setState({form_is_opened: false, data_to_edit: {}})
  }

  renderList() {
    return this.props.data.groups.map(group => (
      <tr key={group.id} onClick={() => {
        if (getUserPermissions('core.groups.update')) {
          this.setState({form_is_opened: true, data_to_edit: group})
        }
      }
      }>
        <td>
          <b>{group.id}</b>
        </td>
        <td>
          {group.name}
        </td>
        <td>
          {getUserPermissions('core.groups.update') &&
          <Button id="edit-group-btn" color="warning" className="float-right" title="Edit" onClick={(e) => {
            e.stopPropagation()
            this.setState({form_is_opened: true, data_to_edit: group})
          }}>
            <i className="fa fa-edit"/>
          </Button>}
          {getUserPermissions('core.groups.create') &&
          <Button id="clone-group-btn" color="secondary" className="float-right" title="Clone group" onClick={(e) => {
            e.stopPropagation()
            this.setState({form_is_opened: true, data_to_edit: { permissions: group.permissions, clonedFromGroupId: group.id }})
          }}>
            <i className="fa fa-copy"/>
          </Button>}
        </td>
      </tr>
    ))
  }

  render() {
    if (this.props.data.error) {
      return (<div>An unexpected error occurred</div>)
    }

    return (
      <BlockWithLoader loading={this.props.data.loading}>
        <UnmountClosed isOpened={this.state.form_is_opened}>
          <GroupForm formToggleFunction={this.handleFormToggle}
            afterSubmitFunction={this.afterSubmit}
            editData={this.state.data_to_edit}
            clearFunction={this.clearEditData}
          />
        </UnmountClosed>
        <CardHeader>
          <b>Groups</b>
          {getUserPermissions('core.groups.create') && !this.state.form_is_opened &&
          <Button color="primary" id="add-new-group-btn"
            className="float-right btn-add-project"
            onClick={() => {
              this.setState({form_is_opened: true})
            }}
          >
            <i className="fa fa-plus"/> Add new group
          </Button>}
        </CardHeader>

        <CardBody>
          <Row>
            <Col md="12">
              <Table hover responsive className="table-project">
                <thead>
                  <tr>
                    <th style={{width: '60px'}}>ID</th>
                    <th>Name</th>
                    <th style={{width: '110px'}}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.data.groups && this.renderList()}
                </tbody>
              </Table>
            </Col>
          </Row>
        </CardBody>
      </BlockWithLoader>
    )
  }
}

const GroupsListWithData = graphql(GroupsFetchQuery, {options: {fetchPolicy: 'network-only'}})(GroupsList)

export default GroupsListWithData



// WEBPACK FOOTER //
// ./src/components/People/GroupsList.js